import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MonthlyReportData } from '@app/models/row-data.interface';

import { ColumnLayout } from '../models/columns-layout';

@Injectable({
  providedIn: 'root'
})
export class MonthlyReportDOS {
  private _monthlyReportDataSubject: BehaviorSubject<MonthlyReportData[]> = new BehaviorSubject([]);
  readonly monthlyReportData$ = this._monthlyReportDataSubject.asObservable();

  private _columnsLayoutSubject: BehaviorSubject<ColumnLayout[]> = new BehaviorSubject(null);
  readonly columnsLayoutData$ = this._columnsLayoutSubject.asObservable();

  private _monthlyReportDateSubject: BehaviorSubject<Date> = new BehaviorSubject(new Date());
  readonly monthlyReportDate$ = this._monthlyReportDateSubject.asObservable();

  updateMonthlyReportData(data: MonthlyReportData[]): void {
    this._monthlyReportDataSubject.next(data);
  }

  updateLayoutSettingsData(layout: ColumnLayout[]): void {
    this._columnsLayoutSubject.next(layout);
  }

  getLayoutSettings(): ColumnLayout[] {
    return this._columnsLayoutSubject.value;
  }

  getMonthlyReportDataSnapshot(): MonthlyReportData[] {
    return this._monthlyReportDataSubject.value;
  }

  updateMonthlyReportDate(data: Date): void {
    this._monthlyReportDateSubject.next(data);
  }

  getMonthlyReportDateSnapshot(): Date {
    return this._monthlyReportDateSubject.value;
  }
}
